class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector("details");
    this.summaryToggle = this.querySelector("summary");
    this.summaryToggle.setAttribute("role", "button");

    this.closeBtn = this.querySelector('button[type="button"]');
    this.onBodyClickEvent = this.onBodyClick.bind(this);
    this.close = this.close.bind(this);
    this.onSummaryClick = this.onSummaryClick.bind(this);
  }

  connectedCallback() {
    this.closeBtn?.addEventListener("click", this.close);
    this.detailsContainer?.addEventListener("keyup", (event) => event.code.toUpperCase() === "ESCAPE" && this.close());
    this.summaryToggle?.addEventListener("click", this.onSummaryClick);
  }

  disconnectedCallback() {
    this.trigger?.removeEventListener("click", this.close);
    this.detailsContainer?.removeEventListener(
      "keyup",
      (event) => event.code.toUpperCase() === "ESCAPE" && this.close(),
    );
    this.summaryToggle?.removeEventListener("click", this.onSummaryClick);
  }

  isOpen() {
    return this.detailsContainer.hasAttribute("open");
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest("details").hasAttribute("open") ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains("modal-overlay")) this.close(false);
  }

  open(event) {
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.body.addEventListener("click", this.onBodyClickEvent);
    event.target.closest("details").setAttribute("open", true);
    document.body.style.cssText = `padding-right: ${scrollbarWidth}px !important;`;
    document.body.classList.add("overflow-hidden");

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])'),
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute("open");
    document.body.removeEventListener("click", this.onBodyClickEvent);
    document.body.style.cssText = "";
    document.body.classList.remove("overflow-hidden");

    /* Ensures closing of Algolia's autocomplete layout on modal close */
    const aaPanel = document.querySelector(".aa-Panel");
    if (aaPanel) {
      aaPanel.remove();
    }
  }
}

customElements.define("details-modal", DetailsModal);
